/** Permiso de menú/admin de Mis Compañías. No reutilizar flows.menu.perfil.clients. */
export const MY_COMPANIES_MENU_PERMISSIONS = [
	'flows.menu.perfil.mycompanies',
	'flows.admin',
] as const;
